import { render, staticRenderFns } from "./AddUpdateFAQ.vue?vue&type=template&id=41af3046&"
import script from "./AddUpdateFAQ.vue?vue&type=script&lang=js&"
export * from "./AddUpdateFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports